import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import stepsActions from 'actions/stepsActions';
import PropTypes from 'prop-types';
import SignatureKey from './SignatureKey';

const SignatureKeyStepper = ({ immStepsState, stepsActions }) => {
    const moveToNextStep = () => {
        const currentStep = immStepsState.get('currentStep');

        stepsActions.finalizeStep({ index: currentStep, finished: true });
        stepsActions.enableFinishedAndNextStep();
        stepsActions.changeCurrentStep({
            index: currentStep + 1,
        });
    };

    return <SignatureKey moveToNextStep={moveToNextStep} />;
};

SignatureKeyStepper.propTypes = {
    immStepsState: PropTypes.object.isRequired,
    stepsActions: PropTypes.object.isRequired,
};

export default connect(
    state => ({
        immStepsState: state.steps,
    }),
    dispatch => ({
        stepsActions: bindActionCreators(stepsActions, dispatch),
    })
)(SignatureKeyStepper);
